import ShippingId from '@/components/Shippings/ListItemId'
import ShippingExternalId from '@/components/Shippings/ListItemExternalId'
import ListItemTaskHooksLastResponse from '@/components/Integrations/ListItemTaskHooksLastResponse'
import { sanitizeModel } from '@/common/utils/modelDecorator'

export default {
  computed: {
    shippingTaskHooks() {
      return sanitizeModel({
        title: 'Shipping Task Hooks',
        fetchItems: async (ctx) => {
          let totalRows
          this.$store?.dispatch('hideSpinner')
          if (!this.firstRun) {
            this.selectAllTrigger = false
            // console.log('ARGH', ctx)
            let params = {
              page: (ctx.currentPage - 1),
              limit: ctx.perPage
            }
            if (this.$route.query.qf) {
              console.log(JSON.parse(this.$route.query.qf))
              params = { ...params, search: { ...JSON.parse(this.$route.query.qf) } }
              console.log(params)

              params.search = JSON.parse(this.$route.query.qf).name
            }

            if (ctx.sortBy) {
              params = { ...params, sort: ctx.sortBy + ' ' + (ctx.sortDesc ? 'desc' : 'asc'), sortDirection: ctx.sortDesc ? 'desc' : 'asc' }
              console.log(params)
            }

            return await this.$http.get(this.$appConfig.integrations.g3.apiUrl + 'tasks', { before: this.setG3Auth, params })
              .then(response => {
                const items = response.body.data
                totalRows = response.body.pagination.total
                this.$emit('itemsLoaded', items)
                this.$emit('totalRows', totalRows)
                return { items, totalRows }
              }).catch(error => {
                console.log(error)
                return []
              })
          } else {
            this.firstRun = false
            return []
          }
        },
        fields: [
          {
            key: 'id',
            sortable: false,
            label: this.$gettext('ID')
          },
          {
            key: 'storeId',
            label: this.$gettext('Store ID'),
            component: (value, key, item) => {
              return {
                is: ShippingExternalId,
                shipping: { external_code: value }
              }
            }
          },
          {
            key: 'shippingId',
            label: this.$gettext('Shipment ID'),
            component: (value, key, item) => {
              const isUuid = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/.test(value)
              const component = isUuid ? ShippingId : ShippingExternalId
              return {
                is: component,
                shipping: { id: value, external_code: value }
              }
            }
          },
          {
            key: 'path',
            formatter: (value, key, item) => {
              return `<pre><code>${value}</code></pre>`
            }
          },
          {
            key: 'status',
            sortable: false,
            label: this.$gettext('Status')
          },
          {
            key: 'restingAttempts',
            sortable: false,
            label: this.$gettext('Resting Attempts')
          },
          {
            key: 'body',
            label: this.$gettext('Body'),
            component: (value, key, item) => {
              return {
                is: ListItemTaskHooksLastResponse,
                data: JSON.stringify(value)
              }
            }
          },
          {
            key: 'lastResponse',
            label: this.$gettext('Last Response'),
            component: (value, key, item) => {
              return {
                is: ListItemTaskHooksLastResponse,
                data: item.lastResponse
              }
            }
          },
          {
            key: 'createdAt',
            sortable: false,
            label: this.$gettext('Created At'),
            formatter: (value, key, item) => {
              return this.$options.filters.tabledatetime(value, this.$tz, this.frontConfig.i18n.moment)
            }
          },
          {
            key: 'updatedAt',
            sortable: false,
            label: this.$gettext('Updated At'),
            formatter: (value, key, item) => {
              return this.$options.filters.tabledatetime(value, this.$tz, this.frontConfig.i18n.moment)
            }
          },
          {
            key: 'scheduledDate',
            sortable: false,
            editable: false,
            label: this.$gettext('Sched. At'),
            formatter: (value, key, item) => {
              return this.$options.filters.tabledatetime(value, this.$tz, this.frontConfig.i18n.moment)
            }
          }
        ]
      })
    }
  },
  methods: {
    setG3Auth(req) {
      return req.headers.set('x-api-key', this.$appConfig.integrations.g3.apiKey)
    }
  }
}
